import { Controller } from '@hotwired/stimulus';

import { bindAccordionDetailsAccessibility } from '../utils/accordion_details_a11y';

export default class extends Controller {
  connect() {
    this.unbind = bindAccordionDetailsAccessibility(this.element);
  }

  disconnect() {
    if (this.unbind) this.unbind();
  }
}
